import { useLayoutEffect, ComponentType, FC } from 'react';

import { PopupsStore } from '../../stores/Popups/PopupsStore';

export function withPopupLayer(Component: ComponentType): FC {
  return (props: any) => {
    useLayoutEffect(() => {
      PopupsStore.addLayer();
      return () => {
        PopupsStore.removeLayer();
      };
    }, []);

    return <Component {...props} />;
  };
}
